import { IonContent, IonPage, IonCol, IonRow, IonText } from '@ionic/react';
import React from 'react';
import './UnauthorizedPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import PageHeader from '../../components/PageHeader/PageHeader';

const UnauthorizedPage: React.FC<IRouteInfo> = (props:IRouteInfo) => {

  return (
    <IonPage>
      <PageHeader {...props} />
      <IonContent>
        <IonRow>
          <IonCol>
            <IonText className="unauthorized-notice" color="danger"> 
              You are not authorized to view this page.
            </IonText>
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};

export default UnauthorizedPage;
